import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function CaseStudies() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Case Studies</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Case studies
            <br />
            from policy to proof
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Realistic engagement narratives: controls implemented, evidence automated, audit outcomes improved.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/offerings" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white hover:opacity-95">
              See offerings →
            </Link>
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-3">
            {[ 
              {
                t: "Bank: SOC evidence automation",
                d: "Mapped RBI SOC controls to SIEM use-cases and automated evidence reports; improved audit readiness and response cadence.",
                links: [
                  { label: "RBI", href: "/frameworks/india/rbi" },
                  { label: "Dashboards", href: "/dashboards" },
                ],
              },
              {
                t: "Fintech: DPDPA consent + DSAR rollout",
                d: "Implemented consent flows, withdrawal, DSAR workflows and reporting; reduced manual workload and improved SLA compliance.",
                links: [
                  { label: "DPDPA", href: "/frameworks/india/dpdpa" },
                  { label: "Technology mapping", href: "/technology-mapping" },
                ],
              },
              {
                t: "Insurer: Third-party risk controls",
                d: "Operationalized vendor assessment cadence and evidence tracking; strengthened audit defensibility.",
                links: [
                  { label: "Offerings", href: "/offerings" },
                  { label: "Contact", href: "/contact#contact-form" },
                ],
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                <div className="mt-5 flex flex-wrap gap-3">
                  {x.links.map((l) => (
                    <Link key={l.href} to={l.href} className="focus-ring inline-flex h-10 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                      {l.label} →
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Request sector-specific case studies</div>
            <div className="mt-3 text-sm text-text-secondary">We can share anonymized reference architectures and outcomes by sector.</div>
            <div className="mt-6">
              <ContactForm title="Case study request" subtitle="Tell us your sector and frameworks." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
